<template>
	<div class="all-photos">
		<a :href="'/#/photoalbums/' + post.slug" class="photo-post" v-for="post in posts">
			<div class="inside">
				<img :src="post.cover">
				<p>{{ post.name }}</p>
				<i>{{ post.date_time }}</i>
			</div>
		</a>
	</div>
</template>

<script type="text/javascript">

	module.exports = {
		data: function(){
			return {
				main: 'https://dnz-kalynka.pp.ua/api/photoalbums/',
				posts: []
			}
		},
		methods: {
			getContent: function(){
				var postId = this.$route.params.id
				this.$http.get(this.main).then(function(response){
					this.posts = response.data
					// console.log(response.data)
				}, function(error){
					console.log('Помилка при отриманні даних')
				})
			}
		},
		created: function(){
			this.getContent()
		},
		watch: {
			'$route': {
				deep: true,
					handler: function (refreshPage) {
					this.getContent()
				}
			}
		}
	}

</script>


// WEBPACK FOOTER //
// src/views/photo-report.vue